import '../Inscription.less';
import {Radio, Comment,Avatar,Layout, Select,Badge, Row, Col,ConfigProvider,Table,Modal,Menu,Input, Space ,notification,AutoComplete, Card } from 'antd';
import React, { Component } from "react";
import cabezal from '../static/img/Cabezal_Music.jpg'
import 'react-phone-input-2/lib/style.css'
import es_ES from 'antd/lib/locale/es_ES';
import {NavLink} from "react-router-dom";
import { Button } from 'antd';
import Highlighter from 'react-highlight-words';
import { SearchOutlined,CalendarOutlined,EditOutlined,FileTextOutlined,FileZipOutlined, AuditOutlined,ReadOutlined,DownloadOutlined,QrcodeOutlined,LogoutOutlined} from '@ant-design/icons';
import moment from 'moment'
import axios from "axios";
import {getAuthors,getAuthorsStr,IP,countDownNotification, downloadFile,getComments} from '../components/utils';
import Foot from "../components/Footer"
import JuryMenu from "../components/JuryMenu"
class JuryPlays extends Component {
  constructor(props){
    super(props)
    const { Option } = Select;

    this.state={
      plays:[],
      showArticle:false,
      record:null,
      name:'',
      juryId:undefined,
      showCommentSection:false,
      comment:{},
      jurys_dict:{},
      edit_comment:undefined,
      selected_comment:undefined,
      comment_new_text:undefined,
      loaded_table_data:false,
      qualifications_dict:{},
      qualifications_changed:{},
    }
  }

  async componentWillMount() {
    //Jury
    const response_jury= await fetch(IP + 'api/musica/jurado/',{
      method: "get",
      credentials: "same-origin",
      headers: {
        "Authorization": localStorage.getItem("Authorization") ,
        "Accept": "application/json",
        "Content-Type": "application/json"
      },
    });
    const json_jury = await response_jury.json();
    if(json_jury['detail']){
      localStorage.clear()
      window.location.reload(); 
    }
    var role = localStorage.getItem("Jurado")
    if(!role || role !='musica'){
      localStorage.clear()
      window.location.reload(); 
    }
    const jury_user = localStorage.getItem("User")
    const current_jury = json_jury.filter(j=>j.usuario.toLowerCase() ==jury_user.toLowerCase())[0]

    

    //Qualifications
    var qual_url = new URL(IP + 'api/musica/calificacion/')
    const qualifications = await fetch(qual_url);
    const json_qualifications = await qualifications.json()
    const qualifications_dict={}
    json_qualifications.forEach(element => {
      if(element.jurado == current_jury.id)
        qualifications_dict[element.obra] = element
    });
    const json_plays = await response_plays.json();
    const jurys_dict={}
    Object.entries(json_jury).forEach(element => {
      jurys_dict[element[1].id]=element[1]
    });


    //Plays
    const response_plays = await fetch(IP + 'api/musica/obra/',{
      method: "get",
      credentials: "same-origin",
      headers: {
        "Authorization": localStorage.getItem("Authorization") ,
        "Accept": "application/json",
        "Content-Type": "application/json"
      },
    });
    
    var data = []
    this.authorsStr = new Set();
    this.auths = new Set();
    this.codes = new Set();
    this.titles = new Set();
    this.dates = new Set();
    this.pseudos = new Set();
    this.edits = [];
    
    const Moment = require('moment');
    var new_comments={}
    for(var i in json_plays){
      var item = json_plays[i];
      new_comments[item.id] = 0
      var date= new Moment(item.fecha_registro).format('DD-MM-YYYY')
      var author= getAuthors(item.conc)
      var a= getAuthorsStr(item.conc)
      for(var j in a ){
        this.authorsStr.add(a[j])
      }
      var authorStr = getAuthorsStr(item.conc).join(", ")
      this.auths.add(author)
      this.titles.add(item.titulo);
      this.dates.add(date);
      this.edits.push("")
      this.pseudos.add(item.pseudonimo)
      const year = date.split('-')[2]
      this.codes.add(year+'_'+item.id);

      data.push(
          { 
              id : item.id,
              title : item.titulo,
              author: author ,
              authorStr:authorStr,
              date:date,
              pseudo: item.pseudonimo,
              code:year+'_'+item.id,
              conc:item.conc,
              pdf:item.pdf,
              pdf:item.pdf,
              edit:''
          });
    };
    data.sort((a,b)=>(qualifications_dict[a.id]?.puntaje == 2  && qualifications_dict[b.id]?.puntaje != 2) ? -1000 : a.id< b.id ? -1 : 1)
    
    this.auths = [...this.auths].map((v)=>{
      return {value:v}
    })
  
    this.codes = [...this.codes].map((v)=>{
      return {value:v}
    })
    this.titles = [...this.titles].map((v)=>{
      return {value:v}
    })
    this.dates = [...this.dates].map((v)=>{
      return {value:v}
    })

    this.pseudos = [...this.pseudos].map((v)=>{
      return {value:v}
    })
    
    this.authorsStr = [...this.authorsStr].map((v)=>{
      return {value:v}
    })
    //Last access to comments
    const last_comments_access = await fetch(IP + `api/musica/acceso_comentario/?jurado=${current_jury.id}`,{
      method: "get",
      credentials: "same-origin",
      headers: {
        "Authorization": localStorage.getItem("Authorization") ,
        "Accept": "application/json",
        "Content-Type": "application/json"
    },
    });
    const json_last_comments_access = await last_comments_access.json()
    const last_comments_acces = {}
    json_last_comments_access.forEach(access => {
      last_comments_acces[access.obra] = new Moment(access.fecha).format()
    });

    //Comments
    const comments = await fetch(IP + `api/musica/comentario/`,{ method: "get",
    credentials: "same-origin",
    headers: {
      "Authorization": localStorage.getItem("Authorization") ,
      "Accept": "application/json",
      "Content-Type": "application/json"}})
    const json_comments = await comments.json();
    json_comments.forEach(c=>{
      if(!last_comments_acces[c.obra] || moment(c.fecha).isAfter(last_comments_acces[c.obra])){
        new_comments[c.obra] =  new_comments[c.obra] + 1
      }
    })
    this.setState({juryId:current_jury.id, name:current_jury.nombre_completo, jurys_dict:jurys_dict,plays: data ,loaded_table_data:true,qualifications_dict:qualifications_dict, new_comments:new_comments});

  }

  onClickArticle = record  => {
        this.setState({showArticle:true,record:record});
  };

  hideModal = () => {
        this.setState({
          showArticle: false,
          record: null,
        });
  };
async saveQualification(record_id){
  if (record_id in this.state.qualifications_changed){
    if(!(record_id in this.state.qualifications_dict)){//if it didn't exist, we have to post
      const data= new FormData()
      data.append('jurado',this.state.juryId)
      data.append('obra',record_id)
      data.append('puntaje',this.state.qualifications_changed[record_id])
      axios.post(IP + 'api/musica/calificacion/', data).then((res) => {
        countDownNotification(notification.success,'Completado','La calificación se guardó de forma exitosa','success')
      }).catch((err) => {
        notification.error({
          message:'Error',
          description:"Hubo un error. Intente mas tarde por favor",
        });
    })}
    else{//if it did exist, we have to patch
      var options = {
        method: "patch",
        credentials: "same-origin",
        headers: {
          "Authorization": localStorage.getItem("Authorization") ,
          "Accept": "application/json",
          "Content-Type": "application/json"},
       
      }
      var editedQualification = {
        puntaje: this.state.qualifications_changed[record_id]
      }
      await axios.patch(IP + `api/musica/calificacion/${this.state.qualifications_dict[record_id].id}/`, editedQualification, options)
      .then(
        (response) => {
         if(response.status === 200)
         countDownNotification(notification.success,'Completado','La calificación se guardó de forma exitosa','success')
        },
        (error) => {
          countDownNotification(notification.error, "Error", "Hubo un error al guardar los cambios.Intente más tarde por favor","failure")
        }
      ).catch((err) => countDownNotification(notification.error, "Error", "Hubo un error al guardar los cambios.Intente más tarde por favor","failure"))
    }
    var newqualifications_changed = {...this.state.qualifications_changed}
    delete newqualifications_changed[record_id]
    this.setState({qualifications_changed:{...newqualifications_changed}})
  }

}

  handleTableChange = (pagination, filters, sorter, extra) => {
    this.setState({
      filteredInfo: extra['currentDataSource']
    });
  }
  getAutocomplete = (dataIndex) =>{
    if(dataIndex == "code"){
      return this.codes
    }
    
      else if (dataIndex == "title" ) {
        return this.titles
    } 

    else if (dataIndex== "author"){
      return  this.authorsStr
    }

    else if (dataIndex== "pseudo"){
      return this.pseudos
    }
    
    else{
      return this.dates
    }
  }
  async postComment(play_id,parentComment){
  
    const data= new FormData()
    data.append('jurado',this.state.juryId)
    data.append('obra',play_id)
    data.append('texto',this.state.comment_new_text)
    if(parentComment){
      data.append('comentario_padre',parentComment)
    }
    axios.post(IP + 'api/musica/comentario/', data).then(async (res) => {
      if (res.status == 200){
        const comments_dict = await getComments(play_id)
        this.setState({comment:comments_dict,selected_comment:undefined,answer_comment:false, comment_new_text:''})
      } 
      }).catch((err) => {
        notification.error({
          message:'Error',
          description:"Hubo un error. Intente mas tarde por favor",
        });
    })
  }
  
  async saveEditComment(play_id,commentId){
    var options = {
      method: "patch",
      credentials: "same-origin",
      headers: {
        "Authorization": localStorage.getItem("Authorization") ,
        "Accept": "application/json",
        "Content-Type": "application/json"},
     
    }
    var editedComment = {
      texto: this.state.comment_new_text
    }
    await axios.patch(IP + `api/musica/comentario/${commentId.toString()}/`, editedComment, options)
    .then(
      async(response) => {
       if(response.status === 200)
       var comments_dict = await getComments(play_id)
       this.setState({comment:comments_dict,edit_comment:false,selected_comment:undefined, comment_new_text:undefined},()=>countDownNotification(notification.success,'Completado','El mensaje se guardó de forma exitosa','success'))
      },
      (error) => {
        console.log(error);
      }
    ).catch((err) => console.log(err))
  }
  
  async deleteComment(play_id,commentId){
    fetch(IP + `api/musica/comentario/${commentId.toString()}/`,{
      method:'DELETE',
      credentials: "same-origin",
      headers: {
        "Authorization": localStorage.getItem("Authorization") ,
        "Accept": "application/json",
        "Content-Type": "application/json"},
     
    }).then(async (res) => {
      if (res.status == 204){
        var comments_dict = await getComments(play_id)
        this.setState({comment:comments_dict},()=>countDownNotification(notification.success,'Completado','El mensaje se eliminó de forma exitosa','success'))
      } 
      }).catch((err) => {
        notification.error({
          message:'Error',
          description:"Hubo un error. Intente mas tarde por favor",
        });
    })
  }
  editComment(comment){
    this.setState({edit_comment:true,selected_comment:comment.id, comment_new_text:comment.texto})
  }
  cancelComment(){
    this.setState({edit_comment:false,selected_comment:undefined,answer_comment:false, comment_new_text:''})
  }
  answerComment(commentId){
    this.setState({selected_comment:commentId,answer_comment:true,edit_comment:false})
  }
  
  getChildComments(comment){
      const { TextArea } = Input;
      return (this.state.edit_comment && this.state.selected_comment == comment.id &&
        <Comment
          actions={[<span onClick={()=>this.saveEditComment(comment.obra,comment.id)} >Guardar</span>, <span onClick={()=>this.cancelComment()} >Cancelar</span>]}
          avatar={
            <Avatar
              src={`https://ui-avatars.com/api/name=${this.state.jurys_dict[comment.jurado].nombre_completo}&background=random`}
              alt={this.state.jurys_dict[comment.jurado].nombre_completo}
            />
          }
          content={
            <TextArea value={this.state.comment_new_text} onChange={(val)=>{this.setState({comment_new_text:val.target.value})}}/>
          }
        >
          {comment.respuestas.map(id => {
           return this.getChildComments(this.state.comment[id])
        })}
        </Comment>
           
        || (this.state.answer_comment && this.state.selected_comment == comment.id &&
          <Comment
            actions={comment.jurado==this.state.juryId ? [<span onClick={()=>this.editComment(comment)}>Editar</span>,<span onClick={()=>this.deleteComment(comment.obra, comment.id)} >Eliminar</span>,<span onClick={()=>this.answerComment(comment.id)} >Responder</span>]: [<span onClick={()=>this.answerComment(comment.id)}>Responder</span>]}
            author={<a>{this.state.jurys_dict[comment.jurado].nombre_completo}</a>}
            avatar={
              <Avatar
                src={`https://ui-avatars.com/api/name=${this.state.jurys_dict[comment.jurado].nombre_completo}&background=random`}
                alt={this.state.jurys_dict[comment.jurado].nombre_completo}
              />
            }
            content={
              <p>
              {comment.texto}
              </p>
            }
            datetime={
                <span>{moment(comment.fecha).format('YYYY-MM-DD HH:mm:ss')}</span>
            }
            >
              <Comment
                actions={[<Button type="primary" disabled={!this.state.comment_new_text || this.state.comment_new_text.replaceAll(/\s/g,'') === ""}  onClick={()=>this.postComment(this.state.currentRecordId,comment.id)} >Comentar</Button>, <Button type="text" onClick={()=>this.cancelComment()} >Cancelar</Button>]}
                avatar={
                  <Avatar
                    src={`https://ui-avatars.com/api/name=${this.state.name}&background=random`}
                    alt={this.state.name}
                  />
                }
                content={
                  <TextArea placeholder="Escriba " value={this.state.comment_new_text} onChange={(val)=>{this.setState({comment_new_text:val.target.value})}}/>
                }
              > 
            </Comment>
              {comment.respuestas.map(id => {
                  return this.getChildComments(this.state.comment[id])
              })}
          </Comment>
        ) ||
        <Comment
          actions={comment.jurado==this.state.juryId ? [<span onClick={()=>this.editComment(comment)} key="comment-basic-edit-to">Editar</span>,<span  onClick={()=>this.deleteComment(comment.obra, comment.id)}  key="comment-basic-delete-to">Eliminar</span>,<span onClick={()=>this.answerComment(comment.id)}  key="comment-basic-reply-to">Responder</span>]: [<span onClick={()=>this.answerComment(comment.id)}  key="comment-basic-reply-to">Responder</span>]}
          author={<a>{this.state.jurys_dict[comment.jurado].nombre_completo}</a>}
          avatar={
            <Avatar
              src={`https://ui-avatars.com/api/name=${this.state.jurys_dict[comment.jurado].nombre_completo}&background=random`}
              alt={this.state.jurys_dict[comment.jurado].nombre_completo}
            />
          }
          content={
            <p>
            {comment.texto}
            </p>
          }
          datetime={
              <span>{moment(comment.fecha).format('YYYY-MM-DD HH:mm:ss')}</span>
          }
        >
        {comment.respuestas.map(id => {
           return this.getChildComments(this.state.comment[id])
        })}
        </Comment>
      )
     
    }
  getColumnSearchProps = (dataIndex,nombre) => ({
        filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
          <div style={{ padding: 8 }}>
            <AutoComplete 
            style={{ width: 188, marginBottom: 8, display: 'block' }}
            options={this.getAutocomplete(dataIndex)}
            filterOption={(inputValue,option)=>option.value.toUpperCase().indexOf(inputValue.toUpperCase()) !== -1}
            onChange={(value)=>{setSelectedKeys(value ? [value] : [])}}
            value={selectedKeys[0]}
            >
              <Input
                ref={node => {
                  this.searchInput = node;
                }}
                placeholder={`Buscar ${nombre}`}
                onPressEnter={() => this.handleSearch(selectedKeys, confirm, dataIndex)}
              />
            </AutoComplete>
            <Space>
              <Button
                type="primary"
                onClick={() => this.handleSearch(selectedKeys, confirm, dataIndex)}
                icon={<SearchOutlined />}
                size="small"
                style={{ width: 90 }}
              >
                Buscar
              </Button>
              <Button onClick={() =>{setSelectedKeys([]); this.handleReset(clearFilters)}} size="small" style={{ width: 90 }}>
                Resetear
              </Button>
            </Space>

          </div>
        ),
        filterIcon: filtered => <SearchOutlined style={{ color: filtered ? '#1890ff' : undefined }} />,
        onFilter: (value, record) =>
          dataIndex!="author"?
           (record[dataIndex]
            ? record[dataIndex].toString().normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase().includes(value.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase())
            : ''):
            (record[dataIndex]? record[dataIndex].some(auth=>auth['name'].normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase().includes(value.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase())):'')
       ,
        onFilterDropdownVisibleChange: visible => {
          if (visible) {
            setTimeout(() => this.searchInput.select(), 100);
          }
        },
        render: (text,record,index) =>

           this.state.searchedColumn === dataIndex ? (
             dataIndex !="author"?
            (<div style={{fontSize:'large' }}>
            <Highlighter
              highlightStyle={{ backgroundColor: '#ffc069', padding: 0 }}
              searchWords={[this.state.searchText]}
              autoEscape
              textToHighlight={text ? text.toString() : ''}
            />
            </div>):
            record[dataIndex].map(auth=>
            (<div style={{fontSize:'large' }}>
            <Highlighter
              highlightStyle={{ backgroundColor: '#ffc069', padding: 0 }}
              searchWords={[this.state.searchText]}
              autoEscape
              textToHighlight={auth['name'] ? auth['name'] : ''}
            />
            </div>))
          ) : (
            <div style={{fontSize:'large', backgroundColor: 'white' }}>
              {(dataIndex=="author" && <ol>{record.author.map((a,idx)=>{return <li><a onClick = {()=>this.onClickArticle(record)} >{a.name}</a> </li>})}</ol> )
              || (text )  }
            </div>
          ),
      });
    
      handleSearch = (selectedKeys, confirm, dataIndex) => {
        confirm();
        this.setState({
          searchText: selectedKeys[0],
          searchedColumn: dataIndex,
        });
      };
      async openComments(record){
        var comments_dict = await getComments(record ? record:this.state.record.id)
        this.setState({showCommentSection:true, currentRecordId:record ? record:this.state.record.id, comment:comments_dict})
      }
      handleReset = clearFilters => {
        clearFilters();
        this.setState({ searchText: '' });

      };
    async acceptTerms(){
      var options = {
        method: "patch",
        credentials: "same-origin",
        headers: {
          "Authorization": localStorage.getItem("Authorization") ,
          "Accept": "application/json",
          "Content-Type": "application/json"},
        }
      var juryChanged={
        acepta_terminos: true,
      }
       
       await axios.patch(IP + `api/musica/jurado/${this.state.juryId}/`, juryChanged, options)
       .then(
         (response) => {
           if(response.status === 200){
            this.setState({termsAccepted:true},()=>countDownNotification(notification.success,'Bienvenido','','success'))
           }
            else{
              countDownNotification(notification.success,'Error','Hubo un error en la conexión, por favor intente más tarde','error')
            }
         },
         (error) => {
          notification.error({
            message:'Error',
            description:'Hubo un error, por favor revise los datos',
          })
         }
       ).catch((err) => console.log(err) )
    }
    
  render() {
   
      const { Content } = Layout;
      const Moment = require('moment');
      const columns = [
                
                  {
                    title: <div style={{fontWeight:'bold', fontSize:'large'}}>Número</div>,
                    dataIndex: 'code',
                    key: 'code',
                    width:150,
                    ...this.getColumnSearchProps('code','número'),
                    responsive: ['sm'] 
                  },
                  {
                    title: <div style={{fontWeight:'bold', fontSize:'large'}}>Título</div>,
                    dataIndex: 'title',
                    key: 'title',
                    ...this.getColumnSearchProps('title','título'),
                    responsive: ['sm'] 
                  },
                
                  {
                    dataIndex:"id",
                    key:"id",
                    align:'center',
                    width:130 ,
                    render: (text,record)=> {
                      return {
                        props: {
                          style: { background: "white",fontSize:'large',}
                        },
                        children:  
                       <Button onClick={() => downloadFile(record)} ><FileZipOutlined/>  Descargar</Button>
                      }

                  }},
                  {
                    dataIndex:"id",
                    key:"id",
                    align:'center',
                    width:150 ,
                    render: (text,record)=> {
                      return {
                        props: {
                          style: { background:  "white",fontSize:'large',width:130 }
                        },
                        children:  <div> <Badge size="small" count={this.state.new_comments[record.id]} overflowCount={100}>
                       
                      <Button onClick={() => this.openComments(record.id)} ><FileTextOutlined />  Comentarios</Button></Badge></div>
                      }} 

                  },
                    {
                      title: <div style={{ fontWeight:'bold', fontSize:'large', textAlign:'center'}}>
                      Calificación</div>,
                      dataIndex: 'cal',
                      key: 'cal',
                      align:'right',
                      width:399,
                      render: (text,record)=> {
                        return {
                          props: {
                            style: { background:'#d9d9d9',fontSize:'large' }
                          },
                          children:   
                          <Radio.Group 
                            defaultValue={this.state.qualifications_dict[record.id]?this.state.qualifications_dict[record.id].puntaje:undefined}
                            onChange={(event)=>{
                              var new_qualifications={...this.state.qualifications_changed};
                              
                              new_qualifications[record.id]=event.target.value
                              this.setState({qualifications_changed:{...new_qualifications}})}} 
                            >
                          
                          <Space >
    
                         <Radio style={{color:'red',borderBlockColor:'red'}} value={1}>Eliminada</Radio>
                          <Radio style={{color:'#ffff80'}}  value={2}>Preseleccionada</Radio>
                          <Radio  disabled={!this.state.qualifications_dict[record.id] || this.state.qualifications_dict[record.id] && this.state.qualifications_dict[record.id].puntaje != 3} style={{color:'green',borderBlockColor:'green'}}  value={3}>Recomendada</Radio>
                          </Space>
                        </Radio.Group>
                        }},  
                      responsive: ['sm'] 
                    },
                 {
                  dataIndex:"id",
                  key:"id",
                  align:'center',
                  width:'84',
                  render: (text,record)=> {
                    return {
                      props: {
                        style: { background:  "#d9d9d9",fontSize:'large'}
                      },
                      children:   
                     <Button disabled={!(text in this.state.qualifications_changed)} onClick={()=>this.saveQualification(text)}>Guardar</Button>
                    }} },
            ];
    
   

    
    const { SubMenu } = Menu;
    const closeComments=async ()=>{
      const Moment = require('moment');

      const data= new FormData()
      data.append('jurado',this.state.juryId)
      data.append('obra',this.state.currentRecordId)
      axios.post(IP + 'api/musica/acceso_comentario/', data).then(async (res) => {
        if (res.status == 200){
         console.log("OK")
        } 
        }).catch((err) => {
          console.log("ERROR")
      })
      const last_comments_access = await fetch(IP + `api/musica/acceso_comentario/?jurado=${this.state.juryId}`,{
        method: "get",
        credentials: "same-origin",
        headers: {
          "Authorization": localStorage.getItem("Authorization") ,
          "Accept": "application/json",
          "Content-Type": "application/json"
      },
      });
      const json_last_comments_access = await last_comments_access.json()
      const last_comments_acces = {}
      json_last_comments_access.forEach(access => {
        last_comments_acces[access.obra] = new Moment(access.fecha).format()
      });
      const comments = await fetch(IP + `api/musica/comentario/`,{ method: "get",
      credentials: "same-origin",
      headers: {
        "Authorization": localStorage.getItem("Authorization") ,
        "Accept": "application/json",
        "Content-Type": "application/json"}})
      const json_comments = await comments.json();
      var new_comments = {}
      json_comments.forEach(c=>{
        if(!last_comments_acces[c.obra] || moment(c.fecha).isAfter(last_comments_acces[c.obra])){
          new_comments[c.obra] =  new_comments[c.obra]?  new_comments[c.obra] + 1 : 1
        }
       
      })
      this.setState({showCommentSection:false,editComment:false, selected_comment:undefined,new_comments:new_comments})
    }
    const { TextArea } = Input;
    return (

      <div className="page-container">
      <div className = "content-wrap">
      <ConfigProvider locale={es_ES}>
            <Layout style={{backgroundColor:'white'}}>
            <JuryMenu defaultSelectedKey={"plays_final"} name ={this.state.name}/>
            <Content>
            <Card style={{backgroundColor:'#d9d9d9'}}>
              <Row justify="center" align="middle">
                <Col span={22}>
                  
                <Table
                loading={!this.state.loaded_table_data}
                  columns={columns}
                  dataSource= {this.state.plays}
                  pagination={{ position: ["bottomCenter"],}} 
                  tableLayout='fixed'
                  size='small'
                  style={{ whiteSpace: 'normal'}}
                  onChange = {this.handleTableChange}
                />
                    
                </Col> 
              </Row>
              </Card>

            {
                  this.state.showArticle && 
                  <Modal 
                      closable = {false}
                      title={ this.state.record.code}
                      visible={this.state.showArticle} 
                      onCancel={this.hideModal}
                      footer={[
                        
                          <Button key="back" onClick={this.hideModal}>
                          Regresar
                          </Button>,
                            
                      ]}
                      >
                      

                        <p><FileTextOutlined />Título: {this.state.record.title}</p>
                      
                      <p><QrcodeOutlined />Código: {this.state.record.code}  </p>
                      <p><CalendarOutlined />Fecha: {this.state.record.date}   </p>

                      
                      <p><AuditOutlined />Seudónimo: {this.state.record.pseudo} </p>

                      
                      <p>

                        <Button onClick={downloadFile} >
                        <FileZipOutlined/>  Descargar PDF
                          </Button>
                        <Button onClick={() => this.openComments()} ><FileTextOutlined />  Comentarios</Button>
                      </p>

                  </Modal>
                  }
                    { this.state.showCommentSection && <Modal 
                      closable = {false}
                      title={ "Comentarios"}
                      visible={this.state.showCommentSection} 
                      width={580}
                      
                      footer={[
                        
                          <Button key="back" onClick={closeComments}>
                          Cerrar
                          </Button>,
                            
                      ]}
                      >
                      <Row align="middle" justify="center" >
                        <Col span={24}>
                        <Comment
                          actions={[<Button disabled={this.state.edit_comment || this.state.answer_comment || !this.state.comment_new_text || this.state.comment_new_text.replaceAll(/\s/g,'') === ""} type="primary" onClick={()=>this.postComment(this.state.currentRecordId)} >Comentar</Button>, <Button type="text" onClick={()=>this.cancelComment()} >Cancelar</Button>]}
                          avatar={
                              <Avatar
                                src={`https://ui-avatars.com/api/name=${this.state.jurys_dict[this.state.juryId].nombre_completo}&background=random`}
                                alt={this.state.jurys_dict[this.state.juryId].nombre_completo}
                              />
                          }
                          content={
                            <TextArea disabled={this.state.edit_comment || this.state.answer_comment} placeholder={"Añadir comentario"} value={!this.state.edit_comment && !this.state.answer_comment && this.state.comment_new_text} onChange={(val)=>{this.setState({comment_new_text:val.target.value})}}/>
                          }
                        />
          
                        {
                          Object.entries(this.state.comment).map(element=>{
                            if (!element[1].comentario_padre){
                              return this.getChildComments(element[1])
                            }
                          })
                          
                        }
                        </Col>
                      </Row>
                  </Modal>}
                  <Modal
                  closable={false}
                  footer={[
                        
                    <Button key="accept" onClick={()=>this.acceptTerms()}>
                    Aceptar
                    </Button>,
                      
                ]}
                    visible={this.state.jurys_dict && this.state.juryId && !this.state.jurys_dict[this.state.juryId].acepta_terminos && !this.state.termsAccepted } 
                  >
                    <Row align="middle" justify="center" >
                      <Col span={24}>
                      <p>Si ha sido seleccionado como jurado y da su consentimiento, est&aacute; aceptando:</p>
                      <ol>
                      <li>Que recibir&aacute; las obras en concurso que sean puestas a su disposici&oacute;n en la p&aacute;gina <a href="https://premiocasa.cu/musicologia/jurado">https://premiocasa.cu/musicologia/jurado</a> identific&aacute;ndose con la contrase&ntilde;a que le sea suministrada por los administradores.</li>
                      <li>Que ser&aacute; depositario de esas obras y se abstendr&aacute; de utilizar las mismas para fines distintos ajenos al concurso, o cualquier acto de divulgaci&oacute;n de todo o parte de las mismas, con excepci&oacute;n de los intercambios entre los miembros del jurado con los que participe.</li>
                      <li>Que mantendr&aacute; total confidencialidad sobre los datos a los que tenga acceso por raz&oacute;n del concurso, as&iacute; como sobre las discusiones que en relaci&oacute;n con las obras se suscite.</li>
                      <li>Que una vez concluidas las deliberaciones y emitida el Acta del jurado, destruir&aacute; los archivos y datos sobre los autores que haya recibido para la realizaci&oacute;n de este encargo.</li>
                      </ol>
                      </Col>
                    </Row>
                  </Modal>
            </Content>
          </Layout>
        </ConfigProvider>
    </div>
    <Foot jury={true}/>
    </div>

    );
  }
}
export default JuryPlays;


